var map = {
	"./Loading icon.png": "2cbe",
	"./TUTORIAL.png": "616e",
	"./bg.jpg": "6864",
	"./buy/05a_Buy_Persona.jpg": "5328",
	"./buy/05b_Buy_651.jpg": "2837",
	"./buy/05c_Buy_651.jpg": "75f7",
	"./buy/05d_Buy_651.jpg": "33f0",
	"./buy/05e_Buy_Scene.jpg": "2b6c",
	"./buy/05f_Buy_Scene.jpg": "31a4",
	"./buy/05g_Buy_Scene.jpg": "f380",
	"./buy/05h_Buy_Scene.jpg": "bbcc",
	"./buy/05i-Buy_Callidus01.jpg": "788d",
	"./buy/05j-Buy_Callidus02.jpg": "4141",
	"./buy/05k-Buy_Callidus03.jpg": "2517",
	"./close.png": "7252",
	"./help.png": "b8ac",
	"./iPd-Frame.png": "1a0f",
	"./info-grey.png": "0717",
	"./info.png": "77f4",
	"./learn/07_Learn_More.jpg": "edc3",
	"./left-arrow-button.png": "2990",
	"./left-arrow-hover.png": "c193",
	"./left-arrow.png": "c2db",
	"./next.png": "d39c",
	"./offer/02a_marketing.jpg": "2292",
	"./offer/02b_marketing.jpg": "e0cc",
	"./offer/02d_marketing.jpg": "c4c3",
	"./offer/02e_marketing.jpg": "f29f",
	"./offer/02f_marketing.jpg": "c74a",
	"./offer/02g_marketing.jpg": "88e8",
	"./offer/02h_marketing.jpg": "1451",
	"./offer/02i_marketing.jpg": "fb15",
	"./offer/02j_marketing.jpg": "419f",
	"./offer/02k_marketing.jpg": "398e",
	"./offer/02l_marketing.jpg": "8c1c",
	"./offer/02m_marketing.jpg": "7065",
	"./offer/02n_marketing.jpg": "532b",
	"./offer/02o_marketing.jpg": "1948",
	"./offer/02p_marketing.jpg": "9907",
	"./offer/02q_marketing.jpg": "d7ef",
	"./offer/02r_marketing.jpg": "807e",
	"./offer/02s_marketing.jpg": "e915",
	"./right-arrow-button.png": "3b60",
	"./right-arrow-hover.png": "f2dd",
	"./right-arrow.png": "3907",
	"./seeit/01 See_651px.jpg": "84dc",
	"./seeit/01a_Pinterest_651px.jpg": "2941",
	"./seeit/01b_Pinterest_651px.jpg": "58ad",
	"./seeit/01c See_651px.jpg": "d5c2",
	"./seeit/01d See_651px.jpg": "63ee",
	"./seeit/01e See_651px.jpg": "9bac",
	"./seeit/01f See_651px.jpg": "1691",
	"./seeit/01g See_651px.jpg": "577a",
	"./seeit/01h See_651px.jpg": "7916",
	"./seeit/01i See_651px.jpg": "c601",
	"./share/06a_Share_Persona.jpg": "d492",
	"./share/06b_Share_Gigya01.jpg": "3443",
	"./share/06d_Share_Persona.jpg": "51e7",
	"./share/06e_Share_Gigya02.jpg": "f4a9",
	"./shop/04-Shop_Persona.jpg": "3696",
	"./shop/04a_Shop_1a.jpeg": "1925",
	"./shop/04c-Shop_651.jpg": "7b01",
	"./shop/04d-Shop_651.jpg": "dd75",
	"./shop/04e-Shop_651.jpg": "8810",
	"./shop/04f-Shop_651.jpg": "8285",
	"./shop/04g-Shop_651.jpg": "1a93",
	"./shop/04h-Shop_651.jpg": "c66f",
	"./shop/04i-Shop_651.jpg": "e247",
	"./shop/04j-Shop_651.jpg": "86b4",
	"./shop/04k-Shop_Persona.jpg": "f7a9",
	"./shop/04l-Shop_651.jpg": "9adf",
	"./shop/04m-Shop_651.jpg": "baa5",
	"./shop/04n-Shop_651.jpg": "e5a0",
	"./shop/04o-Shop_651.jpg": "70fc",
	"./shop/04p-Shop_651.jpg": "db9f",
	"./shop/04q-Shop_651.jpg": "7245",
	"./shop/04r-Shop_651.jpg": "2204",
	"./shop/04s-Shop_651.jpg": "d637",
	"./store/03_Store_1Persona.jpg": "282d",
	"./store/03_Store_2Scene.jpg": "274a",
	"./store/03a_Store_651.jpg": "56f6",
	"./store/03c_Store_651.jpg": "8714",
	"./store/03e_Store_651.jpg": "7fc5",
	"./store/03g_Store_651.jpg": "bfa1",
	"./store/03j_Store_651.jpg": "fc1d",
	"./store/03k_Store_651.jpg": "aa70",
	"./store/03l_Store_651.jpg": "afc1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0828";